import React from 'react';
import './LeadIn.css';

interface ILeadInProps {
  title?: string;
  subtitle?: string;
}

const LeadIn = ({ title, subtitle }: ILeadInProps) => {
  return (
    <div className="leading">
      {title && <h1 className="title">{title}</h1>}
      {subtitle && <p className="subtitle">{subtitle}</p>}
    </div>
  );
};

export default LeadIn;



// WEBPACK FOOTER //
// ./src/components/LeadIn/LeadIn.tsx